import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { CognitoUtil } from 'src/app/shared/utils/cognito.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-dashboard-active-issues-management',
  templateUrl: './dashboard-active-issues-management.component.html',
  styleUrls: ['./dashboard-active-issues-management.component.scss'],
})
export class DashboardActiveIssuesManagementComponent
  implements OnInit, OnDestroy
{
  subscription: Subscription | undefined;
  sharedData: any;
  readonly LANG_CONST = LANG_CONST;

  constructor(
    public cognitoUtil: CognitoUtil,
    private stateManagementService: StateManagementService,
    public sharedDataService: SharedDataService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.stateManagementService.updateShowHeader(true);

    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData: any) => {
        this.sharedData = sharedData;
      }
    );
  }
  navigateBack() {
    this.router.navigate(['/dashboard']);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
